/**
 * The blank draft a new funnel starts as.
 *
 * MINIMAL BY INTENT, and Q-039 is open on it. `packages/schema` requires at
 * least one band and nothing else, so this supplies exactly one and invents no
 * thresholds — a three-band ladder here would be scoring policy written by the
 * list screen, and Story 7.1 is the Qualify tab that owns it. The label reads
 * as the placeholder it is.
 *
 * HERE, NOT IN THE API, SINCE STORY 27.4. It lived in `services/funnels/list.ts`
 * while only the server started funnels. One-shot generation applies a
 * proposal's operations to this funnel on the server (Story 27.3), and the
 * dashboard's review applies the parts a person ticks to the same funnel before
 * anything is created, to say whether they make a funnel the save accepts — so
 * both read the one definition, and neither can start from a funnel the other
 * would not.
 */
import type { Archetype } from './archetype'

export function blankFunnel(input: {
  id: string
  orgId: string
  workspaceId: string
  name: string
  archetype: Archetype
}) {
  return {
    schema_version: 1,
    meta: {
      id: input.id,
      org_id: input.orgId,
      workspace_id: input.workspaceId,
      name: input.name,
      version: 1,
      archetype: input.archetype,
    },
    settings: {},
    theme_ref: { kind: 'inherit' as const },
    steps: [],
    blocks: [],
    logic: [],
    rubric: {
      criteria: [],
      extraction: [],
      icp_profile: '',
      disqualifiers: [],
      bands: [
        {
          id: 'band_unsorted',
          label: 'Not yet banded',
          min: 0,
          max: 100,
          tone: 'nurture' as const,
          is_qualified: false,
        },
      ],
    },
    outcomes: [],
    voice: {},
    routing: [],
  }
}
